/*
  Black Friday early-access page (ML-216): countdown + sticky CTA visibility.
  Carousel, marquee and accordion behaviour come from the theme's own custom elements.
*/

if (!customElements.get('bf-countdown')) {
  customElements.define('bf-countdown', class extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      if (Number.isNaN(this.end)) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 15000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const minutes = Math.max(0, Math.floor((this.end - Date.now()) / 60000));
      const values = { days: Math.floor(minutes / 1440), hours: Math.floor(minutes / 60) % 24, minutes: minutes % 60 };
      for (const [unit, value] of Object.entries(values)) {
        const el = this.querySelector(`[data-unit="${unit}"]`);
        if (el) el.textContent = String(value).padStart(2, '0');
      }
      if (minutes === 0) clearInterval(this.timer);
    }
  });
}

// Hidden while a signup form is on screen (a quarter of it, so a sliver under the sticky
// header doesn't count), and for good once Klaviyo reports a submit.
if (!customElements.get('bf-sticky-cta')) {
  customElements.define('bf-sticky-cta', class extends HTMLElement {
    connectedCallback() {
      const visible = new Set();
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => (entry.intersectionRatio >= 0.25 ? visible.add(entry.target) : visible.delete(entry.target)));
        this.classList.toggle('is-hidden', this.submitted || visible.size > 0);
      }, { threshold: [0, 0.25] });
      document.querySelectorAll('.bf-form-card').forEach((form) => this.observer.observe(form));

      this.onKlaviyo = (event) => {
        if (event.detail?.type !== 'submit') return;
        this.submitted = true;
        this.classList.add('is-hidden');
      };
      window.addEventListener('klaviyoForms', this.onKlaviyo);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('klaviyoForms', this.onKlaviyo);
    }
  });
}
